<template>
    <div class="product-detail">

        <v-card>
            <v-card-title style="background-color: rgb(33, 57, 141); color: white;">{{$t('product.product')}}</v-card-title>
            <v-card-text>
                <v-container>
                    <v-form v-model="valid">
                        <v-layout>
                            <v-flex sm6 px-3>
                                <v-text-field
                                        v-model="form.attributes.title"
                                        v-bind:label="$t('product.title')"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.number"
                                        v-bind:label="$t('product.number')"
                                        required
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.customer_number"
                                        v-bind:label="$t('product.customer_number')"
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.description"
                                        v-bind:label="$t('product.description')"
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.extra_description"
                                        v-bind:label="$t('product.extra_description')"
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.extra_dimension"
                                        v-bind:label="$t('product.extra_dimension')"
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.material"
                                        v-bind:label="$t('product.material')"
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.width"
                                        v-bind:label="$t('product.width')"
                                        suffix="mm"
                                ></v-text-field>
                                <v-text-field
                                        v-model="form.attributes.height"
                                        label="height"
                                        suffix="mm"
                                        v-bind:label="$t('product.height')"
                                ></v-text-field>
                                <v-btn right @click="saveAction" color="primary">
                                    {{$t('message.save')}}
                                </v-btn>
                            </v-flex>
                            <v-flex sm6 px-3>
                                <v-combobox
                                        v-model="form.relationships['product-types'].data"
                                        :items="product_types"
                                        item-text="attributes.title"
                                        v-bind:label="$t('product.productType')"
                                ></v-combobox>
                                <v-combobox
                                        v-model="form.relationships['product-categories'].data"
                                        :items="product_categories"
                                        item-text="attributes.title"
                                        v-bind:label="$t('product.productGroup')"
                                ></v-combobox>
                                <v-combobox label="related"></v-combobox>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>


    </div>
</template>

<script>
    import {Response} from 'jsonapi-flatten'

    export default {
        mounted() {
            if (this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('products/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['products/byId']({id: this.id});
                    this.form = widget;

                    var parent = widget;
                    this.$store.dispatch('productTypes/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['productTypes/related']({parent});
                        this.form.relationships['product-types'].data = related;
                    });

                    var parent = widget;
                    this.$store.dispatch('productCategories/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['productCategories/related']({parent});
                        this.form.relationships['product-categories'].data = related;
                    });

                    var parent = widget;
                    this.$store.dispatch('productReleaseTypes/loadRelated', {parent}).then(() => {
                        const related = this.$store.getters['productReleaseTypes/related']({parent});
                        this.form.relationships['product-release-types'].data = related;
                    });

                });
            } else {

            }

            this.$store.dispatch('productTypes/loadAll').then(() => {
                const widgets = this.$store.getters['productTypes/all'];
                widgets.forEach((item) => {
                    this.product_types.push(item);
                });
            });

            this.$store.dispatch('productCategories/loadAll').then(() => {
                const widgets = this.$store.getters['productCategories/all'];
                widgets.forEach((item) => {
                    this.product_categories.push(item);
                });
            });

            this.$store.dispatch('productReleaseTypes/loadAll').then(() => {
                const widgets = this.$store.getters['productReleaseTypes/all'];
                widgets.forEach((item) => {
                    this.product_release_types.push(item);
                });
            });

        },
        methods: {
            saveAction: function () {
                if (this.$route.params.id != null) {
                    var widget = this.$store.getters['products/byId']({id: this.id});
                    widget = this.form;
                    delete widget.relationships['product-types'].data.attributes;
                    delete widget.relationships['product-types'].data.links;
                    delete widget.relationships['product-categories'].data.attributes;
                    delete widget.relationships['product-categories'].data.links;
                    delete widget.relationships['product-release-types'].data.attributes;
                    delete widget.relationships['product-release-types'].data.links;
                    delete widget.relationships['product-release-types'].data.relationships;

                    if(widget.relationships['product-release-types'].data.type == undefined)
                        delete widget.relationships['product-release-types'];

                    this.$store.dispatch('products/update', widget).then(() => {
                         this.$router.back();
                    });
                } else {
                    var widget = this.form;

                    delete widget.relationships['product-types'].data.attributes;
                    delete widget.relationships['product-types'].data.links;
                    if(widget.relationships['product-types'].data.type == undefined)
                        delete widget.relationships['product-types'];

                    delete widget.relationships['product-categories'].data.attributes;
                    delete widget.relationships['product-categories'].data.links;
                    if(widget.relationships['product-categories'].data.type == undefined)
                        delete widget.relationships['product-categories'];

                    delete widget.relationships['product-release-types'].data.attributes;
                    delete widget.relationships['product-release-types'].data.links;
                    if(widget.relationships['product-release-types'].data.type == undefined)
                        delete widget.relationships['product-release-types'];

                    if(Object.keys(widget.relationships).length === 0) delete widget.relationships;
                    console.log(widget);

                    this.$store.dispatch('products/create', widget).then(() => {
                        this.$router.back();
                    });
                }
            }
        },
        data: () => ({

            form: {
                attributes: {
                    title: null,
                    number: null,
                    customer_number: null,
                    description: null,
                    extra_description: null,
                    file: null,
                    extra_dimension: null,
                    material: null,
                    width: null,
                    height: null,
                    revision: null,
                    revision_date: null
                },
                relationships: {
                    'product-types': {data: {}},
                    'product-categories': {data: {}},
                    'product-release-types': {data: {}}
                },

            },


            itemtype: "",

            valid: false,


            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ],

            product_types: [],
            product_categories: [],
            product_release_types: [],

            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],

            standard: false,
            show_protocol: false,


        })
    }
</script>

